import React, { useState } from 'react';
import { submitFeePayment } from '../../../shared/utils/lateFees';

// Member "I Paid Late Fee" submission (mirrors MemberPaymentSubmitModal, but for
// a fee and entirely separate from the contribution handshake). The fee amount is
// fixed (the charge); the member optionally records method/reference/note.
const METHODS = [
  { value: 'zelle', label: 'Zelle' },
  { value: 'cash_app', label: 'Cash App' },
  { value: 'venmo', label: 'Venmo' },
  { value: 'bank_transfer', label: 'Bank Transfer' },
  { value: 'cash', label: 'Cash' },
  { value: 'other', label: 'Other' },
];

const FeePaymentSubmitModal = ({ fee, onClose, onSuccess }) => {
  const isEdit = fee.state === 'pending';
  const s = fee.submission;
  const [method, setMethod] = useState(isEdit ? (s?.method || '') : '');
  const [reference, setReference] = useState(isEdit ? (s?.reference || '') : '');
  const [note, setNote] = useState(isEdit ? (s?.note || '') : '');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async () => {
    setLoading(true); setError(null);
    try {
      await submitFeePayment({ feeId: fee.id, method, reference, note });
      onSuccess();
    } catch (e) { setError(e.message); setLoading(false); }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-end sm:items-center justify-center p-4 z-50" onClick={onClose}>
      <div className="bg-neutral-100 rounded-t-2xl sm:rounded-lg w-full sm:max-w-sm p-5" onClick={e => e.stopPropagation()}>
        <div className="w-10 h-1 bg-neutral-300 rounded-full mx-auto mb-4 sm:hidden" />
        <h3 className="text-lg font-semibold text-neutral-900 mb-1">
          {isEdit ? 'Edit Fee Submission' : 'I Paid Late Fee'}
        </h3>
        <p className="text-sm text-neutral-600 mb-4">
          Late fee amount: <strong>${Number(fee.amount || 0).toFixed(2)}</strong>
        </p>

        <label className="block text-sm text-neutral-700 mb-1">Payment method (optional)</label>
        <select value={method} onChange={e => setMethod(e.target.value)}
          className="w-full px-3 py-2 border border-neutral-300 rounded-lg text-sm mb-3">
          <option value="">Select method</option>
          {METHODS.map(m => <option key={m.value} value={m.value}>{m.label}</option>)}
        </select>

        <label className="block text-sm text-neutral-700 mb-1">Reference (optional)</label>
        <input type="text" value={reference} onChange={e => setReference(e.target.value)}
          placeholder="e.g. confirmation #"
          className="w-full px-3 py-2 border border-neutral-300 rounded-lg text-sm mb-3" />

        <label className="block text-sm text-neutral-700 mb-1">Note (optional)</label>
        <input type="text" value={note} onChange={e => setNote(e.target.value)}
          className="w-full px-3 py-2 border border-neutral-300 rounded-lg text-sm mb-3" />

        {error && <p className="text-sm text-error-600 mb-2">{error}</p>}

        <div className="flex gap-2">
          <button onClick={onClose}
            className="flex-1 px-4 py-3 border border-neutral-300 rounded-lg text-base text-neutral-700">Cancel</button>
          <button onClick={handleSubmit} disabled={loading}
            className="flex-1 px-4 py-3 bg-primary-600 text-neutral-50 rounded-lg text-base font-semibold disabled:opacity-50">
            {loading ? 'Submitting…' : (isEdit ? 'Update Submission' : "I Paid — Submit")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default FeePaymentSubmitModal;
